import type { IconProps } from './types';
import './icons.css';

export default function Swap({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-swap ${className || ''}`}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.5"
        d="M6 11.017h13m0 0L13.97 6M19 11.017 13.97 16M27 22.017H14m0 0L19.03 17M14 22.017 19.03 27"
      />
    </svg>
  );
}
